/**
 * Pure parsing for a `whatsNext` cell's joined text (`label~nodeNumber`
 * pairs, `,`/`;`/`|`-separated). Kept in its own file, separate from
 * `routing-intents-field.tsx` (a React component that imports the design
 * system and `tableStore` at runtime): the Build-Stage Canvas edge resolver
 * (`canvas-edges-model.ts`, Project Bobcat Phase 2) needs this exact
 * splitting logic in a node-env unit test, and importing a value out of a
 * component file drags its whole runtime import graph along — the same
 * trap `canvas-view-model.ts` documents avoiding for `table-store.ts`.
 */

export interface WhatsNextBranch {
  label: string;
  destination: string;
}

export const parseWhatsNext = (raw: string): WhatsNextBranch[] =>
  raw
    .split(/[,;|]/)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => {
      const separatorIndex = item.indexOf('~');
      if (separatorIndex === -1) return { label: item, destination: '' };
      return {
        label: item.slice(0, separatorIndex).trim(),
        destination: item.slice(separatorIndex + 1).trim(),
      };
    });
